// Auth API Endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: '/api/auth/authenticate',
  VERIFY_OTP: '/api/auth/verify-otp',
  REGISTER: '/api/auth/register',
  GET_PROFILE: '/api/auth/getprofile',
  UPDATE_PROFILE: '/api/auth/updateprofile',
  SOCIAL_LOGIN: '/api/auth/sociallogin',
  REFRESH_TOKEN: '/api/auth/refreshtoken',
  LOGOUT: '/api/auth/logout',
  FORGOT_PASSWORD: '/api/auth/forgotpassword',
  CHANGE_PASSWORD: '/api/auth/changepassword',
  REQUEST_FORGOT_PASSWORD_OTP: '/api/auth/request-forgot-password-otp',
};

// AppUser API Endpoints
export const APP_USER_ENDPOINTS = {
  GET_LIST: '/api/AppUserAPI/GetAppUserList',
  GET_BY_ID: '/api/AppUserAPI/GetAppUserById',
  SAVE: '/api/AppUserAPI/SaveAppUser',
  DELETE: '/api/AppUserAPI/DeleteAppUser',
  GET_USER_FORM_PERMISSION: '/api/AppUserAPI/GetUserFormPermission',
  GET_FEEDBACK_FORM_PERMISSION: '/api/AppUserAPI/GetFeedbackFormPermission',
};

// Trainer API Endpoints
export const TRAINER_ENDPOINTS = {
  GET_LIST: '/api/Trainer/GetTrainerList',
  GET_BY_ID: '/api/Trainer/GetTrainerById',
  SAVE: '/api/Trainer/SaveTrainer',
  DELETE: '/api/Trainer/DeleteTrainer',
  GET_RATING: '/api/Trainer/rating',
};

// LocalStorage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  MEMBER_ID: 'memberId',
};
